<template>
  <div :class="classList">
    <label v-if="label" class="form-label-btn">
      {{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired && label.trim().length > 0" class="asterisk-mark">
        *
      </span>
      <div class="setting-container" v-if="hasAddOptionBtn">
        <i
          class="material-icons ml-2 add-option-icon"
          @click="$emit('clickBtn', 'add-option')"
          v-tooltip="'Add Option'"
        >
          add_circle_outline
        </i>
      </div>
    </label>
    <label v-if="label === ''" class="no-margin-top"></label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <div v-if="hasCheckAll" class="form-check pl-4">
      <input
        class="form-check-input"
        type="checkbox"
        value="all"
        :id="idCheckAll"
        :checked="listCheckedOption.length === normalizedOptionList.length"
        @change="handleClickCheckAll($event.target.checked)"
      />
      <label class="form-check-label ml-1" :for="idCheckAll"> All </label>
    </div>
    <div class="row">
      <div
        :class="columnClass"
        v-for="(chunk, chunkIndex) of displayOptionList"
        :key="'chunk-' + chunkIndex"
      >
        <div
          class="form-check pl-4"
          v-for="(option, index) in chunk"
          :key="'option-' + optionsPerColumn * chunkIndex + index"
        >
          <div
            v-if="isOptionShow(option)"
            :style="{
              'margin-left':
                mapParentOptions && mapParentOptions[option] ? '1em' : '0',
            }"
          >
            <input
              class="form-check-input"
              type="checkbox"
              :disabled="
                isOptionDisabled(optionsPerColumn * chunkIndex + index)
              "
              :value="option"
              :id="getCheckboxId(chunkIndex, index)"
              :checked="isOptionCheck(option)"
              @change="
                onChangeCheck(
                  option,
                  $event.target.checked,
                  optionsPerColumn * chunkIndex + index
                )
              "
            />
            <label
              class="form-check-label ml-1"
              :for="getCheckboxId(chunkIndex, index)"
              v-if="isHtml"
              v-html="getDisplayOption(option)"
            >
            </label>
            <label
              class="form-check-label ml-1"
              :for="getCheckboxId(chunkIndex, index)"
              v-else
            >
              {{ getDisplayOption(option) }}
            </label>
            <input
              v-if="
                textboxOption.includes(optionsPerColumn * chunkIndex + index)
              "
              type="text"
              class="form-control textbox-option"
              :value="
                getTextboxOptionValue(optionsPerColumn * chunkIndex + index)
              "
              @input="
                handleTextboxOptionInput(
                  $event,
                  optionsPerColumn * chunkIndex + index
                )
              "
            />
          </div>
        </div>
        <div
          v-if="
            chunkIndex === displayOptionList.length - 1 &&
            hasOther &&
            value != null &&
            hasOtherOption
          "
        >
          <input
            type="text"
            class="form-control"
            :value="getOtherValue"
            @input="handleOtherTextboxInput($event)"
            :disabled="isDisabled"
          />
        </div>
      </div>
    </div>
    <p
      class="required-message"
      v-if="listCheckedOption.length === 0 && submitClicked && isRequired"
    >
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
    <div
      class="button-group"
      v-if="listDisplayButtons && listDisplayButtons.length"
    >
      <button
        v-for="button of listDisplayButtons"
        :key="'button-' + button.id"
        @click="handleClickButton(button)"
        class="btn btn-secondary mr-1"
      >
        {{ getLabelByKeys(button.keyLangLabel) }}
      </button>
    </div>
  </div>
</template>
<script>
/* This component includes a label, and a checkbox group, which includes  checkboxes and its label
Any error of the checkbox group (for example: required field) is showed in this component */
import { REGEX_EXTRACT_CHECKBOX_PARENT_OPTION } from "../../../constants/regex";

export default {
  name: "CheckboxGroup",
  props: {
    /* Name of the checkbox component, it is used in id of each checkbox, 
    therefore it need to be different between CheckboxGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: {
      type: Array,
      default: () => [],
    },
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // List of options for checkbox group (the label of each checkbox)
    optionList: {
      type: [Array, String],
      default: () => [],
    },
    // Index of option which has textbox
    textboxOption: {
      type: Array,
      default: () => [],
    },
    hasOther: {
      type: Boolean,
      default: false,
    },
    hasCheckAll: {
      type: Boolean,
      default: false,
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    // Index of default selected option
    defaultValue: Array,
    // Checkbox option display in HTML format
    isHtml: {
      type: Boolean,
      default: false,
    },
    // Display options in multiple columns
    numberOfColumn: {
      type: Number,
      default: 1,
    },
    // Index of exclusive options
    exclusiveOptions: {
      type: Array,
      default: () => [],
    },
    messageDialogs: Array,
    tagData: Object,
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: () => {},
    },
    mapDisplayedOptions: Object,
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    builderField: Object,
    markAllAsChecked: {
      type: Boolean,
      default: false,
    },
  },
  components: {
  },
  // created() {
  //   this.listCheckedOption.push(this.normalizedOptionList[0]);
  //   this.$emit("input", this.listCheckedOption);
  // },
  created() {
    if (this.defaultValue && (this.value == null || this.value.length === 0)) {
      this.listCheckedOption = this.defaultValue.map(
        (val) => this.normalizedOptionList[val]
      );
    }
    // mark all as checked by default
    if (this.markAllAsChecked) {
      this.handleClickCheckAll(true);
    }
  },
  computed: {
    listCheckedOption: {
      get() {
        const result = [];
        if (!this.value) {
          return result;
        }
        this.value.forEach((option) => {
          if (!option) {
            return;
          }
          if (
            this.normalizedOptionList.includes(option) ||
            option.indexOf("textboxOption") === 0 ||
            option.indexOf("other:") === 0 ||
            this.useDuplicateModel
          ) {
            result.push(option);
          }
        });
        return result;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    hasAddOptionBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some((button) => button.id === "add-option");
    },
    hasAgencySettingBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some((button) => button.id === "agency-setting");
    },
    agencySettingBtn() {
      if (!this.hasAgencySettingBtn) {
        return {};
      }
      return this.buttonGroups.find((button) => button.id === "agency-setting");
    },
    listDisplayButtons() {
      if (!this.buttonGroups || !this.buttonGroups.length) {
        return null;
      }
      let result = this.buttonGroups.filter(
        (button) =>
          !button.showIfSelect &&
          button.id !== "add-option" &&
          button.id !== "agency-setting"
      );
      if (this.inputVal) {
        return result;
      }
      return result.filter((button) => !button.showIfSelect);
    },
    normalizedOptionList() {
      let optionList;
      if (Array.isArray(this.optionList)) {
        optionList = this.optionList;
      } else {
        optionList = this.optionList
          .split("\n")
          .map((option) => option.trim())
          .filter((option) => option.length > 0);
      }
      // Replace tag
      return optionList.map((option) => {
        if (this.tagData && option.includes("[[")) {
          return this.replaceTagValue(option, this.tagData);
        } else {
          return option;
        }
      });
    },
    mapParentOptions() {
      if (!this.normalizedOptionList) {
        return {};
      }
      const result = {};
      for (const option of this.normalizedOptionList) {
        if (!option) {
          continue;
        }
        if (String(option).includes("data-parent=")) {
          const match = option.match(REGEX_EXTRACT_CHECKBOX_PARENT_OPTION);
          if (match) {
            if (!isNaN(match[1])) {
              const parentOption = this.normalizedOptionList[Number(match[1])];
              if (parentOption) {
                result[option] = parentOption;
              }
            }
          }
        }
      }
      return result;
    },
    displayOptionList() {
      if (!this.normalizedOptionList) {
        return [];
      }
      if (!this.numberOfColumn) {
        this.numberOfColumn = 1;
      }
      return this.splitArrayIntoChunks(
        this.normalizedOptionList,
        this.numberOfColumn
      );
    },
    getOtherValue() {
      const otherOption = this.listCheckedOption.find(
        (option) => option.indexOf("other:") === 0
      );
      if (otherOption) {
        return otherOption.substr(6);
      }
      return "";
    },
    hasOtherOption() {
      if (this.listCheckedOption == null) {
        return false;
      }
      return this.listCheckedOption.some(
        (option) => option.indexOf("other:") === 0
      );
    },
    optionsPerColumn() {
      if (this.normalizedOptionList == null) {
        return 0;
      }
      if (!this.numberOfColumn) {
        return this.normalizedOptionList.length;
      }
      return Math.ceil(this.normalizedOptionList.length / this.numberOfColumn);
    },
    columnClass() {
      if (this.numberOfColumn == null || this.numberOfColumn === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / this.numberOfColumn);
    },
    idCheckAll() {
      return "checkbox-checkall-" + this._uid;
    },
    useDuplicateModel() {
      return this.builderField && this.builderField.useDuplicateModel;
    },
  },
  methods: {
    /*
    Parse textbox from input value (v-model)
    Structure of input value:
    [selectedOption1, selectedOption2, ..., otherOption, textboxOption1, textboxOption2, ...]
    with:
      otherOption: 'other:' + text
      textboxOption1: 'textboxOption1:' + text
    This method will extract text from textboxOption
    */
    getTextboxOptionValue(index) {
      const textboxOption = this.listCheckedOption.find(
        (option) => option.indexOf(`textboxOption${index}:`) === 0
      );
      if (textboxOption) {
        return textboxOption.substr(`textboxOption${index}:`.length);
      }
      return "";
    },
    // This method will calculate textboxOption based on input text
    handleTextboxOptionInput(event, index) {
      const indexOfOption = this.listCheckedOption.findIndex(
        (option) => option.indexOf(`textboxOption${index}:`) === 0
      );
      if (indexOfOption >= 0) {
        // Update
        this.listCheckedOption[indexOfOption] =
          `textboxOption${index}:` + event.target.value;
      } else {
        // Insert
        this.listCheckedOption.push(
          `textboxOption${index}:` + event.target.value
        );
      }
      this.listCheckedOption = Object.assign([], this.listCheckedOption);
    },
    onChangeCheck(option, isCheck, index) {
      // Check to show message dialog
      if (this.messageDialogs && isCheck) {
        const messageDialog = this.messageDialogs.find(
          (item) => item.options && item.options.includes(index)
        );
        if (messageDialog) {
          this.showResultDialog({ innerHtml: messageDialog.message });
          if (!messageDialog.isSelectable) {
            return;
          }
        }
      }

      if (this.hasOther && index === this.normalizedOptionList.length - 1) {
        if (isCheck) {
          this.listCheckedOption.push("other:");
          this.listCheckedOption = [...this.listCheckedOption];
        } else {
          this.listCheckedOption = this.listCheckedOption.filter(
            (checkedOption) => checkedOption.indexOf("other:") !== 0
          );
        }
      } else {
        if (isCheck) {
          this.listCheckedOption.push(option);
          this.listCheckedOption = [...this.listCheckedOption];
        } else {
          this.listCheckedOption = this.listCheckedOption.filter(
            (checkedOption) => checkedOption !== option
          );
        }
      }
      this.$emit("reloadData");
    },
    handleOtherTextboxInput(event) {
      const indexOfOther = this.listCheckedOption.findIndex(
        (option) => option.indexOf("other:") === 0
      );
      this.listCheckedOption[indexOfOther] = "other:" + event.target.value;
      this.listCheckedOption = [...this.listCheckedOption];
    },
    handleClickCheckAll(isCheck) {
      if (isCheck) {
        this.listCheckedOption = Object.assign([], this.normalizedOptionList);
      } else {
        this.listCheckedOption = [];
      }
    },
    isOptionCheck(option) {
      // Check for other option
      if (
        this.hasOther &&
        this.getOtherValue &&
        this.normalizedOptionList &&
        this.normalizedOptionList.length > 0 &&
        option ===
          this.normalizedOptionList[this.normalizedOptionList.length - 1]
      ) {
        return true;
      }
      return this.listCheckedOption.includes(option);
    },
    // Check if option is disabled
    isOptionDisabled(index) {
      // There is no exclusive option => always enable
      if (!this.exclusiveOptions || !this.exclusiveOptions.length) {
        return false;
      }
      // The option is selected option => enable
      if (
        this.listCheckedOption &&
        this.listCheckedOption.includes(this.normalizedOptionList[index])
      ) {
        return false;
      }
      // Exclusive option is checked
      let hasExclusiveOptionChecked = false;
      for (const optionIndex of this.exclusiveOptions) {
        if (
          this.listCheckedOption &&
          this.listCheckedOption.includes(
            this.normalizedOptionList[optionIndex]
          )
        ) {
          hasExclusiveOptionChecked = true;
        }
      }
      // If exclusive option is checked, all other options is disabled
      if (hasExclusiveOptionChecked) {
        return true;
      }
      // Exclusive option is disabled if any other option is checked
      if (this.exclusiveOptions.includes(index)) {
        if (this.listCheckedOption && this.listCheckedOption.length) {
          return true;
        }
      }
      return false;
    },
    getDisplayOption(option) {
      const mapOptions = this.mapDisplayedOptions || this.mapOptionListByLang;
      if (!mapOptions) {
        return option;
      }
      if (mapOptions[option]) {
        return mapOptions[option];
      }
      return option;
    },
    // Check to show/hide option by parent option (In some case, option is only showed if parent option is checked)
    isOptionShow(option) {
      if (!this.mapParentOptions || !this.mapParentOptions[option]) {
        return true;
      }
      if (!this.listCheckedOption) {
        return false;
      }
      return this.listCheckedOption.includes(this.mapParentOptions[option]);
    },
    handleClickButton(button) {
      this.$emit("clickBtn", button.id);
    },
    getCheckboxId(chunkIndex, index) {
      return (
        "checkbox-" +
        this.name +
        "-" +
        this._uid +
        "-" +
        this.optionsPerColumn * chunkIndex +
        index
      );
    },
  },
};
</script>

<style scoped>
.textbox-option {
  display: inline-block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/CheckboxGroup.vue